import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import dayjs from "dayjs";
import styled, { css } from "styled-components";
export default function RenderDays({ daysForRender, activeDates, currPosition, curValue, isShowToday, isCurrentMonth = false, isDisabled = false, onSelect }) {
    const isActiveCheck = (dayId) => {
        if (currPosition) {
            return activeDates.find(item => item === currPosition.date(dayId).format('YYYY-MM-DD')) ? true : false;
        }
        return false;
    };
    return (_jsx(_Fragment, { children: daysForRender.map((day, index) => {
            var _a;
            const isActive = activeDates ? isActiveCheck(day.id) : true;
            const isSelected = (isCurrentMonth) && dayjs(curValue).format('YYYY-MM-DD') === day.date ? true : false;
            const isToday = (isCurrentMonth && isShowToday) && ((_a = dayjs().format('YYYY-MM-DD') === day.date) !== null && _a !== void 0 ? _a : false);
            return _jsx(Date, { isSelected: isSelected, isShowToday: isShowToday, today: isToday, isActive: isActive, activeDates: Boolean(activeDates), onClick: () => onSelect(day, isActive), isDisabled: isDisabled, children: day.id }, index);
        }) }));
}
;
const Date = styled.div `
    font-size: 0.875rem;
    cursor: pointer;
    user-select: none;

    text-align: center;
    ${props => props.isShowToday && props.today && css `
      background-color: var(--ui-accent-color);
      border-radius: 0.9375rem;
      color: var(--ui-color-white);
    `}

    ${props => props.activeDates && css `
      color: var(--text-third);
    `}

    ${props => props.isDisabled && css `
      color: var(--text-third) !important;
    `}

    ${props => props.isSelected && props.isActive && css `
      /* color: var(--ui-accent-color) !important; */
      background: var(--text-third);
      border-radius: 0.5rem;
    `}

    ${props => props.isSelected && props.isActive && props.isShowToday && props.today && css `
      color: var(--ui-color-white) !important;
    `}

    ${props => props.isActive && css `
      color: var(--text-primary);
    `}
`;
